<div class="app-input-wrapper" [ngClass]="customClass">
  <!-- Header Label -->
  <app-label
    *ngIf="resolvedLabel"
    [text]="resolvedLabel"
    [mandatory]="isRequired"
    [optional]="optional"
    [tooltip]="tooltip"
    [icon]="labelIcon"
    [size]="labelSize"
    [forId]="id"
  ></app-label>

  <!-- Input Field Container -->
  <div
    class="app-input-container"
    [ngClass]="[
      'app-input-container--' + (size || 'md'),
      isFocused ? 'app-input-container--focused' : '',
      hasError ? 'app-input-container--error' : '',
      disabled ? 'app-input-container--disabled' : '',
      readonly ? 'app-input-container--readonly' : '',
      multiline ? 'app-input-container--multiline' : '',
      containerClass
    ]"
    [style.height]="!multiline && resolvedHeight ? resolvedHeight : null"
    [style.minHeight]="!multiline && resolvedHeight ? resolvedHeight : null"
  >
    <!-- Prefix Icon / Text -->
    <span *ngIf="prefixIcon" class="app-input__affix app-input__affix--prefix">
      <img [src]="prefixIcon" alt="" />
    </span>
    <span *ngIf="prefixText" class="app-input__affix-text app-input__affix-text--prefix">
      {{ prefixText }}
    </span>

    <!-- Single-line Input -->
    <input
      #inputRef
      *ngIf="!multiline"
      [attr.id]="id || null"
      [attr.name]="name || null"
      [type]="effectiveType"
      [value]="value"
      (input)="onModelChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.min]="min || null"
      [attr.max]="max || null"
      [attr.step]="step || null"
      [attr.maxlength]="maxlength || null"
      [attr.autocomplete]="autocomplete"
      class="app-input__control"
      [ngClass]="inputClass"
    />

    <!-- Multi-line Textarea -->
    <textarea
      #inputRef
      *ngIf="multiline"
      [attr.id]="id || null"
      [attr.name]="name || null"
      [value]="value"
      (input)="onModelChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [rows]="rows"
      [attr.maxlength]="maxlength || null"
      class="app-input__control app-input__control--textarea"
      [ngClass]="inputClass"
    ></textarea>

    <!-- Clear Button -->
    <button
      type="button"
      *ngIf="clearable && value && !disabled && !readonly"
      class="app-input__clear-btn"
      (click)="handleClear()"
      tabindex="-1"
    >
      <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm2.47-9.53a.75.75 0 0 0-1.06-1.06L8 5.82 6.59 4.41a.75.75 0 0 0-1.06 1.06L6.94 6.88 5.53 8.29a.75.75 0 1 0 1.06 1.06L8 7.94l1.41 1.41a.75.75 0 0 0 1.06-1.06L9.06 6.88l1.41-1.41z"
        />
      </svg>
    </button>

    <!-- Password Visibility Toggle -->
    <button
      type="button"
      *ngIf="type === 'password' && !disabled"
      class="app-input__eye-btn"
      (click)="togglePasswordVisibility()"
      tabindex="-1"
    >
      <svg *ngIf="!isPasswordVisible" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
      <svg *ngIf="isPasswordVisible" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
        <line x1="1" y1="1" x2="23" y2="23"></line>
      </svg>
    </button>

    <!-- Suffix Icon / Text -->
    <span *ngIf="suffixIcon" class="app-input__affix app-input__affix--suffix">
      <img [src]="suffixIcon" alt="" />
    </span>
    <span *ngIf="suffixText" class="app-input__affix-text app-input__affix-text--suffix">
      {{ suffixText }}
    </span>

    <!-- Custom Suffix Slot -->
    <ng-content select="[suffix]"></ng-content>
  </div>

  <!-- Error Message -->
  <div *ngIf="hasError" class="app-input__error">
    {{ errorMsg }}
  </div>

  <!-- Helper Text -->
  <div *ngIf="helperText && !hasError" class="app-input__helper">
    {{ helperText }}
  </div>
</div>
